import { useState } from 'react';
import { corrigeTout } from '../../lib/correcteur';
import { messageTitreLigne } from '../../lib/lignes-document';
import { CorrectionFaite } from '../CorrectionFaite.jsx';
import { C } from '../../theme/palette';
import { Inp } from './Inputs';

/**
 * Champ « Désignation » d'une ligne d'un document déjà enregistré.
 *
 * <p>Le titre saisi n'est transmis que s'il n'est pas vide : un champ vidé
 * reste à l'écran comme brouillon, avec le message qui demande un titre, et le
 * document enregistré garde son titre précédent. Le serveur refuserait sinon
 * toute la pièce.
 *
 * @param {object} props propriétés du composant
 * @param {string} props.value titre enregistré
 * @param {number} props.rang rang de la ligne, compté à partir de 1
 * @param {(titre: string) => void} props.onChange appelé avec un titre non vide
 * @param {string} [props.label] intitulé du champ
 * @param {string} [props.placeholder] exemple affiché dans le champ vide
 * @returns {JSX.Element} le champ et, s'il est vide, son explication
 */
export function ChampDesignation({ value, rang, onChange, label = 'Désignation', placeholder }) {
  // Brouillon vide tant que la personne n'a pas redonné de titre.
  const [brouillon, setBrouillon] = useState(null);
  const message = brouillon === null ? null : messageTitreLigne(brouillon, rang);
  // « Réparation des plaintes » devient « Réparation des plinthes » à la
  // sortie de la case ; « Annuler » rend le titre tapé.
  const [correction, setCorrection] = useState(null);
  return (
    <>
      <Inp
        label={label}
        placeholder={placeholder}
        value={brouillon ?? value ?? ''}
        onChange={(e) => {
          const v = e.target.value;
          setCorrection(null);
          if (messageTitreLigne(v, rang)) {
            setBrouillon(v);
            return;
          }
          setBrouillon(null);
          onChange(v);
        }}
        onBlur={() => {
          if (brouillon !== null) return;
          const r = corrigeTout(value || '');
          if (r.corrections.length === 0) return;
          setCorrection({ avant: value, corrections: r.corrections });
          onChange(r.texte);
        }}
      />
      <CorrectionFaite
        corrections={correction?.corrections}
        onAnnule={() => {
          onChange(correction.avant);
          setCorrection(null);
        }}
      />
      {message && (
        <div
          role="alert"
          style={{
            fontSize: 11,
            fontWeight: 700,
            color: C.red,
            background: C.redL,
            borderRadius: 8,
            padding: '7px 10px',
            margin: '-4px 0 10px',
          }}
        >
          {message}
        </div>
      )}
    </>
  );
}
